import {
    IDate
} from '../index'
import {
    IHistory,
    IHistoryData
} from './index'

export class History implements IHistory {
    readonly id?: number
    readonly date_creation?: IDate
    status?: any

    constructor(data?: IHistoryData) {
        this.id = data?.id;
        this.date_creation = data?.date_creation;
        this.status = data?.status || 'new';
    }

    validate(): boolean {
        return this.validateDate()
    }

    validateDate(): boolean {
        let date: IDate | undefined;
        let d = this.date_creation
        if (typeof d === 'string') {
            let format: RegExp =
              new RegExp('^([0-9]{4}-[0-9]{2}-[0-9]{2})(T[0-9]{2}(:[0-9]{2}(:[0-9]{2}((\\+[0-9]{2}:[0-9]{2})|((\\.[0-9]+)?Z))?)?)?)?$');
            if (!format.test(d)) {
                return false
            } else {
                date = new Date(d);
            }
        } else {
            date = d;
        }
        let today = new Date();
        return !!date && (date < today);
    }
}